import { gql } from '@apollo/client';

const UPDATE_WORKOUT_LIST = gql`
  mutation UpdateWorkoutFavorites($input: workoutFavoritesInput!) {
    updateWorkoutFavorites(input: $input)
  }
`;

export default UPDATE_WORKOUT_LIST;
